import axios from 'axios'
import type { ReleaseDataSummary } from '../../shared/releaseDataTransfer'
import { downloadBlob } from '../utils/download'

export async function previewReleaseDataImport(
	csv: string,
): Promise<ReleaseDataSummary> {
	return (
		await axios.post('/api/release-data/import/preview', csv, {
			headers: { 'Content-Type': 'text/csv' },
		})
	).data
}

export async function importReleaseData(
	csv: string,
): Promise<ReleaseDataSummary> {
	return (
		await axios.post('/api/release-data/import', csv, {
			headers: { 'Content-Type': 'text/csv' },
		})
	).data
}

export async function downloadReleaseData(): Promise<boolean> {
	const response = await axios.get<Blob>('/api/release-data/export', {
		responseType: 'blob',
	})
	const filename =
		String(response.headers['content-disposition'] ?? '').match(
			/filename="([^"]+)"/,
		)?.[1] ?? 'tunetoss-releases.csv'
	return downloadBlob(response.data, filename)
}
